import React, { useState } from 'react'
import { colors } from '../../../../../Components/consts'
import { ASRostersCon, TeamImageCon, RosterTeamTabs } from '../styles'
import { HeadXL } from '../../../../../Components/Typography/Text.styles'
import { Img } from '../../../../../Components/Image/Img'
import { TeamRosterPanel } from './TeamRosterPanel'
import { Tab } from '../../../../../Components/LazyComponents'
import { TabPanel } from '../../../../../Components/Tab/TabPanel'
import { logEvent } from '../../../../../Utils'
import { ANALYTICS_TAGS } from '../../../../../Constant'
import {
  ALL_STAR_IMAGES,
  ROSTER_DESCRIPTION,
  TEAM_TAB_CONFIG,
  WLL_TEAM_TAB_CONFIG,
  WLL_TEAM_TAB_LABELS,
  WLLASGTeamIds,
  wllAsgTeams,
} from '../../../../../Constant/allStar'

export const WLLRosters: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [selectedTeam, setSelectedTeam] = useState<WLLASGTeamIds>(
    WLL_TEAM_TAB_CONFIG.DEFAULT_TEAM
  )
  const [tabValue, setTabValue] = useState<number>(TEAM_TAB_CONFIG.DEFAULT_TAB_INDEX)

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    const team = wllAsgTeams[newValue]?.id || WLL_TEAM_TAB_CONFIG.DEFAULT_TEAM
    setSelectedTeam(team)
    setTabValue(newValue)

    logEvent(ANALYTICS_TAGS.allstar_wll_team_tab_change, {
      team,
      location: TEAM_TAB_CONFIG.ANALYTICS_LOCATION,
    })
  }

  return (
    <ASRostersCon>
      <div className="descCon">
        <p>{ROSTER_DESCRIPTION.WLL}</p>
      </div>
      <TeamImageCon>
        <Img className="teamImg" src={ALL_STAR_IMAGES.wllTeamOne} alt="Team Izzy" />
        <Img className="teamImg" src={ALL_STAR_IMAGES.wllTeamTwo} alt="Team North" />
      </TeamImageCon>
      <HeadXL justify="center" textColor={colors.gray.gray20}>
        Rosters
      </HeadXL>

      <RosterTeamTabs
        selectedTeam={selectedTeam}
        value={tabValue}
        onChange={handleTabChange}
        aria-label="All-Star team rosters"
        indicatorColor="primary"
        centered
      >
        {wllAsgTeams.map((team) => (
          <Tab key={team.id} label={WLL_TEAM_TAB_LABELS[team.id]} />
        ))}
      </RosterTeamTabs>

      {wllAsgTeams.map((team, index) => (
        <TabPanel key={team.id} value={tabValue} index={index}>
          <TeamRosterPanel team={team.id} />
        </TabPanel>
      ))}
    </ASRostersCon>
  )
}